module.exports = __webpack_public_path__ + "static/media/ic_lock.4c74a264.svg";